var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderMin = function SvgFolderMin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FolderMin_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FolderMin_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.791 5.785c-.007-.021-.013-.042-.022-.062a.666.666 0 0 0-.13-.196l-4-4a.664.664 0 0 0-.196-.13c-.02-.01-.041-.015-.063-.022a.66.66 0 0 0-.172-.034c-.015-.002-.027-.009-.042-.009H4.5c-.736 0-1.333.598-1.333 1.333v10.667c0 .735.598 1.333 1.333 1.333h8c.735 0 1.333-.598 1.333-1.333V5.999c0-.014-.007-.027-.008-.042a.662.662 0 0 0-.034-.172zm-2.234-.453H9.833V3.608l1.724 1.724zm-7.057 8V2.665h4V6c0 .368.298.666.666.666H12.5l.001 6.667H4.5z",
    fill: "#606060"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#FolderMin_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FolderMin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFolderMin;